<!-- <app-data-table [columns]="cols" [data]="systems" [title]="title"></app-data-table> -->


<ng-container>
    <app-data-table [columns]="cols" [data]="system" [isCardView]="false" (onPresentView)="getSystem()" [url]="'/master/scheme-step/'"
        [isDeletable]="'/master/step-master' | hasPermission: 'Delete'"  [showAddButton]="'/master/step-master' | hasPermission: 'Add'" [showActions]="canEditSetup" [isEditable]="'/master/step-master' | hasPermission: 'Edit'"  [title]="title" (onAdd)="addSystem()" (viewEventRow)="viewSystem($event)" [isView]="'/master/step-master' | hasPermission: 'View'"
        (onLazyLoadData)="getSystem($event)" [totalRecords]="totalRecords" (editEventRow)="updateSystem($event)"
        (deleteEventRow)="showDeletePopup($event)" [url]="'/master/scheme-step/'">
    </app-data-table>
</ng-container>

<!-- Reusable Dialog for Add/Edit/View -->
<app-reusable-dialog
    [(visible)]="showDialog"
    [config]="dialogConfig"
    [initialData]="formData"
    [viewMode]="viewMode"
    (onSubmit)="onSubmitStep($event)"
    (onCancel)="onCancelDialog()"
    (onClose)="onCloseDialog()">
</app-reusable-dialog>

<p-dialog header="Delete Step" [modal]="true" [(visible)]="showDeleteDialog" [style]="{ width: '30rem' }"
    [maximizable]="true">
    <div class="delete-dialog mt-3">
        <i class="pi pi-trash text-danger custom-delete-icon"></i>
        <span>Are you sure , you want to delete step ?</span>
        <p-button label="Delete" icon="pi pi-trash" severity="danger" [outlined]="true" (click)="deleteSystem()" class="mt-2">
        </p-button>
    </div>
</p-dialog>